import React from 'react';
import { X, UserX } from 'react-feather';
import './UserBlockModal.css';

interface UserBlockModalProps {
  username: string;
  onBlock: (username: string) => void;
  onClose: () => void;
  isBlocked: boolean;
}

export const UserBlockModal: React.FC<UserBlockModalProps> = ({
  username,
  onBlock,
  onClose,
  isBlocked
}) => {
  const handleBlock = () => {
    onBlock(username);
  };

  return (
    <div className="user-block-modal-overlay" onClick={onClose}>
      <div className="user-block-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="user-block-modal-header">
          <h3>User Action</h3>
          <button className="user-block-modal-close-button" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <div className="user-block-modal-body">
          <div className="user-block-modal-user-info">
            <div className="user-block-modal-user-icon">
              <UserX size={24} />
            </div>
            <div className="user-block-modal-user-details">
              <h4>{username}</h4>
              <p>Manage submissions from this user</p>
            </div>
          </div>
          
          {!isBlocked ? (
            <div className="user-block-modal-block-section">
              <p className="user-block-modal-block-description">
                Blocking this user will hide all their future submissions from your filtered view.
              </p>
              <button className="user-block-modal-block-button" onClick={handleBlock}>
                Block User
              </button>
            </div>
          ) : (
            <div className="user-block-modal-blocked-section">
              <p className="user-block-modal-blocked-description">
                This user is currently blocked. You can unblock them in Settings.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 